import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import VueTheMask from 'vue-the-mask';
import VueApexCharts from 'vue3-apexcharts';

import * as Sentry from '@sentry/vue';

const appName = import.meta.env.VITE_APP_NAME || 'Tech OS';

const isLocalEnvironment = import.meta.env.VITE_APP_ENV === 'local';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const vueApp = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(VueTheMask)
            .use(VueApexCharts);

        if (!isLocalEnvironment) {
            console.log('Initializing Sentry');

            Sentry.init({
                app: vueApp,
                dsn: "https://63c69a1efc3df7e0c0a3504867942a36@o4508921928810496.ingest.us.sentry.io/4508922042580992",
                integrations: [
                    Sentry.replayIntegration(),
                ],
                tracesSampleRate: 1.0,
                tracePropagationTargets: [/^https?:\/\//],
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
            });
        }

        vueApp.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});